import translateVector from './translator';

export const translateType = (type) => {
  if (type.tipo != undefined) {
    return type;
  }

  return {
    tipo: type.Tipo,
    tipoSalesForce: type.TipoSalesForce,
    geraAgendamento: type.GeraAgendamento,
    geraSolicitacao: type.GeraSolicitacao,
  };
};

export const translateTodasSolicitacoes = (solicitacao) => {
  if (solicitacao?.assetId != undefined) return solicitacao;
  return {
    assetId: solicitacao?.AssetId,
    ativo: solicitacao?.Ativo,
    caseNumber: solicitacao?.CaseNumber,
    grupo: solicitacao?.Grupo,
    id: solicitacao?.Id,
    status: solicitacao?.Status,
    subgrupo: solicitacao?.Subgrupo,
    dataAgendamento: solicitacao?.DataAgendamento,
    dataAgendamentoFinal: solicitacao?.DataAgendamentoFinal,
    dataCriacaoSolicitacao: solicitacao?.DataCriacaoSolicitacao,
    tipo: solicitacao?.Tipo,
    subject: solicitacao?.Subject,
  };
};

export const translateWorkOrders = (work) => {
  return {
    id: work?.Id,
    apontamento: work?.Apontamento,
    apontamentoMotivo: work?.ApontamentoMotivo,
    status: work?.Status,
    createdById: work?.CreatedById,
    createdDate: work?.CreatedDate,
    lastModifiedById: work?.LastModifiedById,
    lastModifiedDate: work?.LastModifiedDate,
    workTypeId: work?.WorkTypeId,
    description: work?.Description,
  };
};

export const translateGetSolicitacao = (solicitacao) => {
  if (solicitacao?.id != undefined) return solicitacao;

  return {
    id: solicitacao?.Id,
    caseNumber: solicitacao?.CaseNumber,
    grupo: solicitacao?.Grupo,
    subgrupo: solicitacao?.Subgrupo,
    subject: solicitacao?.Subject,
    description: solicitacao?.Description,
    workOrder: translateVector(solicitacao?.WorkOrder, translateWorkOrders),

    compromissoServico: {
      id: solicitacao?.CompromissoServico?.Id,
      earliestStartTime: solicitacao?.CompromissoServico?.EarliestStartTime,
      schedStartTime: solicitacao?.CompromissoServico?.SchedStartTime,
      schedEndTime: solicitacao?.CompromissoServico?.SchedEndTime,
      recursoDisponibilizado: {
        id: solicitacao?.CompromissoServico?.RecursoDisponibilizado?.Id,
        createdDate:
          solicitacao?.CompromissoServico?.RecursoDisponibilizado?.CreatedDate,
        lastModifiedDate:
          solicitacao?.CompromissoServico?.RecursoDisponibilizado
            ?.LastModifiedDate,
        serviceResource: {
          name: solicitacao?.CompromissoServico?.RecursoDisponibilizado
            ?.ServiceResource?.Name,
        },
      },
    },
    owner: {
      id: solicitacao?.Id,
      name: solicitacao?.Name,
    },
    accountId: solicitacao?.AccountId,
    workOrderId: solicitacao?.WorkOrderId,
    nomeConta: solicitacao?.NomeConta,
    contactEmail: solicitacao?.ContactEmail,
    origin: solicitacao?.Origin,
    assetId: solicitacao?.AssetId,
    ativo: solicitacao?.Ativo,
    classificacaoArtigo: solicitacao?.ClassificacaoArtigo,
    status: solicitacao?.Status,
    fase: solicitacao?.Fase,
    observacoes: solicitacao?.Observacoes,
    nomeUsuario: solicitacao?.NomeUsuario,
    suppliedEmail: solicitacao?.SuppliedEmail,
    textoNotificacao: solicitacao?.TextoNotificacao,
    emailResponse: solicitacao?.EmailResponse,
    tipo: solicitacao?.Tipo,
    vistoria: solicitacao?.Vistoria,
    tipo_de_Vistoria: solicitacao?.Tipo_de_Vistoria,
    createdDate: solicitacao?.CreatedDate,
    lastViewedDate: solicitacao?.LastViewedDate,
    lastModifiedDate: solicitacao?.LastModifiedDate,
    closedDate: solicitacao?.ClosedDate,
    anexos: solicitacao?.Anexo,
  };
};

export const translateHome = (item) => {
  if (item.accountIdSalesforce != undefined) return item;
  return {
    aceiteCookies: {
      contaId: item.AceiteCookies?.ContaId,
      id: item.AceiteCookies?.Id,
      criado: item.AceiteCookies?.Criado,
      alterado: item.AceiteCookies?.Alterado,
      deletado: item.AceiteCookies?.Deletado,
    },
    contaImagem: {
      id: item.ContaImagem?.Id,
      criado: item.ContaImagem?.Criado,
      alterado: item.ContaImagem?.Alterado,
      deletado: item.ContaImagem?.Alterado,
      uriImage: item.ContaImagem?.UriImage,
      contaId: item.ContaImagem?.ContaId,
    },
    imoveis: translateVector(item.Imoveis, translateBuilding),
    aceiteTermos: translateVector(item.AceiteTermos, translateAcceptTerms),

    agendamentos: translateVector(
      item.Agendamentos,
      translateAgendamentosAbertos
    ),
    contratosRenegociacao: item.ContratosRenegociacao,

    nome: item.Nome,
    email: item.Email,
    cpfCnpj: item.CpfCnpj,
    accountIdSalesforce: item.AccountIdSalesforce,
    codigoPessoaUau: item.CodigoPessoaUau,
    id: item.Id,
    criado: item.Criado,
    alterado: item.Alterado,
    deletado: item.Deletado,
    confirmado: item.Confirmado,
    tempEmail: item.TempEmail,
  };
};

export const translateAgendamentosAbertos = (agendamento) => {
  if (agendamento?.length == 0 || agendamento?.id != undefined)
    return agendamento;

  return {
    id: agendamento?.Id,
    caseNumber: agendamento?.CaseNumber,
    grupo: agendamento?.Grupo,
    subgrupo: agendamento?.Subgrupo,
    subject: agendamento?.Subject,
    assetId: agendamento?.AssetId,
    ativo: agendamento?.Ativo,
    status: agendamento?.Status,
    compromissoServico: {
      id: agendamento?.CompromissoServico?.Id,
      earliestStartTime: agendamento?.CompromissoServico?.EarliestStartTime,
      schedStartTime: agendamento?.CompromissoServico?.SchedStartTime,
      schedEndTime: agendamento?.CompromissoServico?.SchedEndTime,
      recursoDisponibilizado: {
        id: agendamento?.CompromissoServico?.RecursoDisponibilizado?.Id,
        createdDate:
          agendamento?.CompromissoServico?.RecursoDisponibilizado?.CreatedDate,
        lastModifiedDate:
          agendamento?.CompromissoServico?.RecursoDisponibilizado
            ?.LastModifiedDate,
        serviceResource: {
          name: agendamento?.CompromissoServico?.RecursoDisponibilizado?.Name,
        },
      },
    },
  };
};

export const translateGetSolicitacaoSemAgendamento = (solicitacao) => {
  if (solicitacao?.id != undefined) return solicitacao;
  return {
    id: solicitacao?.Id,
    caseNumber: solicitacao?.CaseNumber,
    grupo: solicitacao?.Grupo,
    subgrupo: solicitacao?.Subgrupo,
    subject: solicitacao?.Subject,
    description: solicitacao?.Description,
    workOrder: solicitacao?.WorkOrder
      ? translateVector(solicitacao?.WorkOrder, translateWorkOrders)
      : null,
    compromissoServico: null,
    owner: {
      id: solicitacao?.Id,
      name: solicitacao?.Name,
    },
    accountId: solicitacao?.AccountId,
    workOrderId: solicitacao?.WorkOrderId,
    nomeConta: solicitacao?.NomeConta,
    contactEmail: solicitacao?.ContactEmail,
    origin: solicitacao?.Origin,
    assetId: solicitacao?.AssetId,
    ativo: solicitacao?.Ativo,
    classificacaoArtigo: solicitacao?.ClassificacaoArtigo,
    status: solicitacao?.Status,
    observacoes: solicitacao?.Observacoes,
    nomeUsuario: solicitacao?.NomeUsuario,
    suppliedEmail: solicitacao?.SuppliedEmail,
    fase: solicitacao?.Fase,
    textoNotificacao: solicitacao?.TextoNotificacao,
    emailResponse: solicitacao?.EmailResponse,
    vistoria: solicitacao?.Vistoria,
    tipo_de_Vistoria: solicitacao?.Tipo_de_Vistoria,
    createdDate: solicitacao?.CreatedDate,
    lastViewedDate: solicitacao?.LastViewedDate,
    lastModifiedDate: solicitacao?.LastModifiedDate,
    closedDate: solicitacao?.ClosedDate,
    tipo: solicitacao?.Tipo,
  };
};

export const translateAcceptTerms = (accept) => {
  if (accept.contaId != undefined || accept.length == 0) return accept;
  return {
    contaId: accept.ContaId,
    TermoId: accept.TermoId,
    id: accept.Id,
    criado: accept.Criado,
    alterado: accept.Alterado,
    deletado: accept.Deletado,
  };
};

export const translateBuilding = (building) => {
  if (building.id != undefined) return building;

  return {
    nome: building.Nome,
    assetIdSalesFoce: building.AssetIdSalesFoce,
    contaId: building.ContaId,
    empreendimentoId: building.EmpreendimentoId,
    empreendimento: {
      empreendimentoIdSalesForce:
        building.Empreendimento?.EmpreendimentoIdSalesForce,
      nome: building.Empreendimento?.Nome,
      acabamento: building.Empreendimento?.Acabamento,
      alvenaria: building.Empreendimento?.Alvenaria,
      estrutura: building.Empreendimento?.Estrutura,
      areaExterna: building.Empreendimento?.AreaExterna,
      fundacao: building.Empreendimento?.Fundacao,
      instalacao: building.Empreendimento?.Instalacao,
      totalAndamento: building.Empreendimento?.TotalAndamento,
      TerritorioServico: building.Empreendimento?.TerritorioServico,
      TimeZone: building.Empreendimento?.TimeZone,
      FusoHorario: building.Empreendimento?.FusoHorario,
      holdingId: building.Empreendimento?.HoldingId,
      holding: {
        nome: building.Empreendimento?.Holding?.Nome,
        id: building.Empreendimento?.Holding?.Id,
        criado: building.Empreendimento?.Holding?.Criado,
        alterado: building.Empreendimento?.Holding?.Alterado,
        deletado: building.Empreendimento?.Holding?.Deletado,
      },
      DataEntrega: building.Empreendimento?.DataEntrega,
      DataUltimaAtualizacaoFotos:
        building.Empreendimento?.DataUltimaAtualizacaoFotos,
      DataFotoTirada: building.Empreendimento?.DataFotoTirada,
      imagens: translateVector(
        building.Empreendimento?.EmpreendimentoFotos,
        translateImage
      ),
      id: building.Empreendimento?.Id,
      criado: building.Empreendimento?.Criado,
      alterado: building.Empreendimento?.Alterado,
      deletado: building.Empreendimento?.Deletado,
    },
    contratos: translateVector(building.Contratos, translateContract),
    StatusSalesforce: building.StatusSalesforce,
    StatusUau: building.StatusUau,
    CodigoObra: building.CodigoObra,
    Bloqueio: building.Bloqueio,
    EntregaChave: building.EntregaChave,
    TerminoGarantia: building.TerminoGarantia,
    Vistoria: building.Vistoria,
    DataVistoria: building.DataVistoria,
    Identificador: building.Identificador,
    CodigosUAU: building.CodigosUAU,
    TipoRegistro: building.TipoRegistro,
    TipoUnidade: building.TipoUnidade,
    OportunidadeIdSalesForce: building.OportunidadeIdSalesForce,
    NomeImovel: building.NomeImovel,
    id: building.Id,
    criado: building.Criado,
    alterado: building.Alterado,
    deletado: building.Deletado,
    contratoInadimplente: building.ContratoInadimplente,
    idVenda: building.IdVenda,
  };
};

export const translateImage = (image) => {
  if (image.id != undefined || image.length == 0) return image;
  return {
    id: image.Id,
    nome: image.Nome,
    Uri: image.Uri,
    origem: image.Origem,
    EmpreendimentoId: image.EmpreendimentoId,
    CriacaoSalesForce: image.CriacaoSalesForce,
    LastModifiedDateSalesForce: image.LastModifiedDateSalesForce,
    criado: image.Criado,
    alterado: image.Alterado,
    deletado: image.Deletado,
    idSalesForce: image.IdSalesForce,
    idAws: image.IdAws,
  };
};
export const translateContract = (contract) => {
  if (contract.id != undefined) return contract;
  return {
    id: contract.Id,
    contratoIdSalesforce: contract.ContratoIdSalesforce,
    numeroContrato: contract.NumeroContrato,
    imovelIdSalesForce: contract.ImovelIdSalesForce,
    contaIdSalesForce: contract.ContaIdSalesForce,
    status: contract.Status,
    imovelId: contract.ImovelId,
    criado: contract.Criado,
    alterado: contract.Alterado,
    deletado: contract.Deletado,
  };
};
